import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-df-bg pt-8 pb-16 px-4">
      <div className="container mx-auto max-w-4xl">
        {/* Header */}
        <div className="mb-10">
          <Link
            to="/"
            className="text-df-accent hover:text-df-accent-hover text-sm transition-colors mb-4 inline-block"
          >
            ← Volver al inicio
          </Link>
          <h1 className="text-3xl md:text-4xl font-cinzel font-bold text-df-text mb-2">
            Política de Privacidad
          </h1>
          <p className="text-df-muted text-sm">
            Última actualización: Noviembre 2026
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8 text-df-text/90 leading-relaxed">
          {/* 1 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              1. Información General
            </h2>
            <p className="text-df-muted">
              En <strong className="text-df-text">Tablero Infinito</strong>, nos comprometemos a proteger la privacidad y seguridad de la información personal de nuestros usuarios. Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos su información personal cuando utiliza nuestro sitio web, tienda en línea y servicios relacionados.
            </p>
            <p className="text-df-muted mt-3">
              Al utilizar nuestros servicios, usted acepta las prácticas descritas en esta política. Le recomendamos leerla detenidamente.
            </p>
          </section>

          {/* 2 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              2. Información que Recopilamos
            </h2>
            <p className="text-df-muted mb-3">Podemos recopilar los siguientes tipos de información:</p>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Datos de identificación:</strong> nombre completo, número de documento de identidad, dirección de correo electrónico, número de teléfono.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Datos de envío:</strong> dirección de entrega, ciudad, departamento, código postal.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Datos de pago:</strong> la información de pago es procesada directamente por nuestro proveedor de pagos (ePayco) y no almacenamos datos de tarjetas de crédito o débito en nuestros servidores.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Datos de navegación:</strong> dirección IP, tipo de navegador, páginas visitadas, tiempo de permanencia, preferencias de productos.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Datos de la cuenta:</strong> nombre de usuario, historial de compras, preferencias de comunicación.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Conversaciones con el asistente de ventas:</strong> los mensajes que escriba en el chat de la página, con su fecha y hora, y un identificador aleatorio de la conversación que se guarda en su navegador. El asistente no le pide datos personales; le recomendamos no escribir en el chat datos de pago, contraseñas ni documentos.</span>
              </li>
            </ul>
          </section>

          {/* 3 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              3. Uso de la Información
            </h2>
            <p className="text-df-muted mb-3">Utilizamos su información personal para los siguientes fines:</p>
            <ul className="space-y-2 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Procesar y gestionar sus pedidos y transacciones.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Enviar confirmaciones de compra, actualizaciones de envío y notificaciones de estado del pedido.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Proporcionar soporte al cliente y responder a consultas.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Responder sus preguntas en el chat de la página y revisar esas conversaciones para mejorar la atención.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Personalizar su experiencia de compra y recomendar productos relevantes.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Enviar comunicaciones de marketing y promociones (solo si ha dado su consentimiento).</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Mejorar nuestros servicios, contenido y funcionalidad del sitio web.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Prevenir fraudes y garantizar la seguridad de las transacciones.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Cumplir con obligaciones legales y regulatorias.</span>
              </li>
            </ul>
          </section>

          {/* 4 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              4. Compartir Información con Terceros
            </h2>
            <p className="text-df-muted mb-3">
              No vendemos ni alquilamos su información personal a terceros. Podemos compartir su información únicamente con:
            </p>
            <ul className="space-y-2 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Proveedores de pago:</strong> ePayco, para procesar sus transacciones de forma segura.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Empresas de envío:</strong> para la entrega de sus pedidos.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Proveedores de servicios tecnológicos:</strong> que nos ayudan a operar y mejorar nuestro sitio web, como el alojamiento del sitio.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Google:</strong> solo si usted decide iniciar sesión con su cuenta de Google; Google nos entrega su nombre y correo electrónico.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Autoridades legales:</strong> cuando sea requerido por ley o para proteger nuestros derechos legales.</span>
              </li>
            </ul>
          </section>

          {/* 5 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              5. Seguridad de los Datos
            </h2>
            <p className="text-df-muted">
              Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción. Estas medidas incluyen el uso de cifrado SSL/TLS para proteger la transmisión de datos, almacenamiento con acceso restringido al personal autorizado y copias de seguridad periódicas.
            </p>
            <p className="text-df-muted mt-3">
              Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro. Aunque nos esforzamos por proteger su información, no podemos garantizar su seguridad absoluta.
            </p>
          </section>

          {/* 6 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              6. Cookies y Tecnologías de Seguimiento
            </h2>
            <p className="text-df-muted">
              Utilizamos cookies y tecnologías similares para mejorar su experiencia de navegación, analizar el uso del sitio y personalizar el contenido. Las cookies son pequeños archivos de texto almacenados en su dispositivo que nos permiten recordar sus preferencias y entender cómo interactúa con nuestro sitio.
            </p>
            <p className="text-df-muted mt-3">
              Puede configurar su navegador para rechazar cookies, aunque esto puede limitar algunas funcionalidades del sitio web.
            </p>
            <p className="text-df-muted mt-3">
              También usamos el almacenamiento local de su navegador para recordar su sesión, su carrito y el identificador de su conversación con el asistente, de modo que pueda retomarla si vuelve a la página. Puede borrarlo desde la configuración de su navegador.
            </p>
          </section>

          {/* 7 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              7. Asistente de Ventas en el Chat
            </h2>
            <p className="text-df-muted">
              El chat de la página es atendido por un asistente automático que responde preguntas sobre juegos, precios, disponibilidad, envíos y compras. Sus respuestas las genera un modelo de lenguaje que funciona en equipos propios de Tablero Infinito: sus mensajes no se envían a proveedores externos de inteligencia artificial.
            </p>
            <p className="text-df-muted mt-3">
              Nuestro equipo puede leer las conversaciones para atenderle mejor, resolver reclamos y mejorar el asistente. Si pide hablar con una persona, el asistente le indica cómo escribirnos por WhatsApp. Las conversaciones se eliminan a los 3 meses de su último mensaje.
            </p>
          </section>

          {/* 8 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              8. Derechos del Usuario
            </h2>
            <p className="text-df-muted mb-3">
              De acuerdo con la legislación colombiana de protección de datos (Ley 1581 de 2012), usted tiene derecho a:
            </p>
            <ul className="space-y-2 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Conocer, actualizar y rectificar sus datos personales.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Solicitar la eliminación de sus datos cuando no exista una obligación legal de conservarlos.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Revocar la autorización para el tratamiento de sus datos.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Solicitar prueba de la autorización otorgada.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Presentar quejas ante la Superintendencia de Industria y Comercio (SIC).</span>
              </li>
            </ul>
            <p className="text-df-muted mt-3">
              Para ejercer estos derechos, puede contactarnos a través de <a href="mailto:tableroinfinito@gmail.com" className="text-df-accent hover:text-df-accent-hover transition-colors">tableroinfinito@gmail.com</a>.
            </p>
            <ul className="space-y-2 text-df-muted mt-3">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Consultas:</strong> las respondemos en un máximo de 10 días hábiles desde que las recibimos. Si no es posible en ese plazo, le informaremos el motivo y la nueva fecha, que no superará 5 días hábiles adicionales.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Reclamos</strong> (corrección, actualización, supresión o revocatoria): indique su nombre, documento, la descripción de los hechos, su dirección o correo de contacto y los documentos que quiera hacer valer. Los atendemos en un máximo de 15 días hábiles, prorrogables hasta 8 días hábiles más, avisándole el motivo.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Antes de presentar una queja ante la Superintendencia de Industria y Comercio debe haber agotado el trámite de consulta o reclamo con nosotros.</span>
              </li>
            </ul>
          </section>

          {/* 9 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              9. Retención de Datos
            </h2>
            <p className="text-df-muted">
              Conservamos su información personal durante el tiempo necesario para cumplir con los fines descritos en esta política, así como para cumplir con nuestras obligaciones legales, resolver disputas y hacer cumplir nuestros acuerdos. Los datos de transacciones se conservan por el período exigido por la normativa fiscal colombiana.
            </p>
            <ul className="space-y-2 text-df-muted mt-3">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Conversaciones con el asistente:</strong> 3 meses desde el último mensaje; después se eliminan. Las copias de seguridad las conservan 30 días más.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Pedidos, pagos y facturación:</strong> el tiempo que exija la normativa comercial y tributaria colombiana.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Cuenta de usuario:</strong> mientras la cuenta esté activa o hasta que usted solicite su eliminación, salvo los datos que debamos conservar por ley.</span>
              </li>
            </ul>
          </section>

          {/* 10 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              10. Menores de Edad
            </h2>
            <p className="text-df-muted">
              Nuestros servicios, incluido el chat, no están dirigidos a menores de 18 años, aunque vendamos juegos para niños: las compras deben hacerlas los adultos. No recopilamos intencionalmente información personal de menores. Si descubrimos que hemos recopilado información de un menor sin el consentimiento parental apropiado, tomaremos medidas para eliminar dicha información.
            </p>
          </section>

          {/* 11 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              11. Cambios en esta Política
            </h2>
            <p className="text-df-muted">
              Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Los cambios serán publicados en esta página con la fecha de la última actualización. Le recomendamos revisar periódicamente esta política para mantenerse informado sobre cómo protegemos su información.
            </p>
          </section>

          {/* Contact */}
          <section className="bg-df-surface border border-df-accent/20 rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              Contacto
            </h2>
            <p className="text-df-muted mb-3">
              Si tiene preguntas o inquietudes sobre esta Política de Privacidad, puede contactarnos a través de:
            </p>
            <ul className="space-y-2 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Correo electrónico: <a href="mailto:tableroinfinito@gmail.com" className="text-df-accent hover:text-df-accent-hover transition-colors">tableroinfinito@gmail.com</a></span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>WhatsApp: <a href="https://wa.me/573021124424" className="text-df-accent hover:text-df-accent-hover transition-colors" target="_blank" rel="noopener noreferrer">+57 302 112 4424</a></span>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
